import script from "./Announcements.vue?vue&type=script&setup=true&lang=js"
export * from "./Announcements.vue?vue&type=script&setup=true&lang=js"

import "./Announcements.vue?vue&type=style&index=0&id=5a2cc9a2&lang=scss"

const __exports__ = script;

export default __exports__